import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import { AvEmptyStateComponent } from '../../../../Shared/Components/av-empty-state/av-empty-state.component';
import { AvPaginatorComponent } from '../../../../Shared/Components/av-paginator/av-paginator.component';
import { AvStatusChipComponent } from '../../../../Shared/Components/av-status-chip/av-status-chip.component';
import { BillingDocumentsFacade } from '../../../../../Facades/Billing/billing-documents.facade';
import { DATE_TIME_FORMAT, VALUE_UNRESOLVED } from '../../../../../Consts/backoffice.const';
import { REFUND_REASON_LABEL } from '../../../../../Enums/money-out.enum';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'av-refund-table',
  standalone: true,
  imports: [DatePipe, DecimalPipe, AvEmptyStateComponent, AvPaginatorComponent, AvStatusChipComponent, TranslateModule],
  templateUrl: './refund-table.component.html',
  styleUrl: './refund-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class RefundTableComponent {
  readonly facade = inject(BillingDocumentsFacade);

  readonly dateTimeFormat = DATE_TIME_FORMAT;
  readonly unresolved = VALUE_UNRESOLVED;
  readonly reasonLabels = REFUND_REASON_LABEL;

  readonly isEmpty = computed<boolean>(
    () => this.facade.refundsState() === 'ready' && this.facade.refunds().length === 0,
  );

  reasonLabel(reason: string | null): string {
    return reason === null ? this.unresolved : this.reasonLabels[reason] || reason;
  }

  goToPage(page: number): void {
    this.facade.goToRefundPage(page);
  }

  changePageSize(pageSize: number): void {
    this.facade.changePageSize(pageSize);
  }
}
